import {createToggleStore} from './createToggleStore'

export default createToggleStore('liveCaption')
